<template>
  <section v-if="pageLoading">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-xl-4">
          <div class="confirmation-box">
            <div class="confirmation-box--logo mb-40">
              <img src="@/assets/images/logo.svg" alt="Expressbank" />
            </div>

            <div class="confirmation-box__item bordered">
              <h6 class="confirmation-box__item--title">{{$t('step-5.service')}}</h6>
              <p class="confirmation-box__item--text">{{storeGetService.title}}</p>
            </div>
            <div class="confirmation-box__item bordered">
              <h6 class="confirmation-box__item--title">{{$t('step-5.branch')}}</h6>
                <p class="confirmation-box__item--text">{{storeGetBranch.name}}</p>
            </div>
            <div class="confirmation-box__item bordered">
              <h6 class="confirmation-box__item--title">{{$t('step-5.date')}}</h6>
                <p class="confirmation-box__item--text">{{storeGetDate}}</p>
            </div>
            <div class="confirmation-box__item">
              <h6 class="confirmation-box__item--title">{{$t('step-5.phone')}}</h6>
              <p class="confirmation-box__item--text">+{{storeGetPhone}}</p>
            </div>
            <div class="confirmation-box__item">
              <h6 class="confirmation-box__item--title">{{$t('step-5.queue')}}</h6>
              <p class="confirmation-box__item--text">{{storeGetQueue}}</p>
            </div>
          </div>
        </div>
        <div class="mt-40 mt-lg-0 col-lg-6 offset-xl-1 col-xl-5">
          <h5 class="success--heading mb-35">{{$t('step-5.success-title')}}</h5>

          <div class="row">
            <div class="col-md-10">
              <p class="success--text mb-24" v-if="false">
                {{$t('step-5.success-text')}}
              </p>
              <p class="success--text">
                {{$t('step-5.success-text-2')}}
                
              </p>

              <div class="success__actions mt-35" v-if="false">
                <div class="row">
                  <div class="col-12 mb-16">
                    <div class="success__action">
                      <span class="success__action--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                          ></path>
                        </svg>
                      </span>
                      <span class="success__action--title"
                        >{{$t('step-5.action-1')}}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 mb-16">
                    <div class="success__action">
                      <span class="success__action--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                          ></path>
                        </svg>
                      </span>
                      <span class="success__action--title">{{$t('step-5.action-2')}}</span>
                    </div>
                  </div>
                  <div class="col-12 mb-16">
                    <div class="success__action">
                      <span class="success__action--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                          ></path>
                        </svg>
                      </span>
                      <span class="success__action--title"> {{$t('step-5.action-3')}}</span>
                    </div>
                  </div>
                  <div class="col-12 mb-16">
                    <div class="success__action">
                      <span class="success__action--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="currentColor"
                            d="M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                          ></path>
                        </svg>
                      </span>
                      <span class="success__action--title"
                        >{{$t('step-5.action-4')}}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RouterActions from "@/mixins/routerActions";

export default {
  data(){
    return {
      pageLoading: false
    }
  },
  mixins: [RouterActions],
  methods: {
    checkPage(){
      if(this.storeGetService && this.storeGetBranch && this.storeGetDate && this.storeGetQueue && this.storeGetPhone){
        this.pageLoading = true;
      } else{
        this.pageLoading = false;
        this.$router.push({
          name: "Step 1"
        });
      }
    },
  },
  created(){
    this.checkPage()
  }
}
</script>